//@ts-strict

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { Observable, Subject } from 'rxjs';
import { BaseApiResponse, PageableApiResponse } from '../../index';
import { ICreatedProductFeedUrl, IGeneratedProductConfiguration, IProductData } from '@services/products/products.types';

@Injectable({
  providedIn: 'root'
})
export class ProductsService {
  public newProduct: Subject<IGeneratedProductConfiguration> = new Subject<object>();

  constructor(private http: HttpClient) {}

  public getProductsList(
    programID: number,
    filters: Record<string, any>,
    sortValues: Record<string, any>
  ): Observable<PageableApiResponse<{ products?: IProductData[] }>> {
    const params = filters;
    params.order_field = sortValues.order_field;
    params.order_type = sortValues.order_type;

    return this.http.get<PageableApiResponse<{ products?: IProductData[] }>>(environment.apiUrl + `/campaigns/${programID}/products/list`, { params });
  }

  public addProductConfiguration(
    program_config_id: number,
    program_product_id: number,
    domain_id: number,
    programID: number | undefined
  ): Observable<BaseApiResponse<ICreatedProductFeedUrl>> {
    const productConfiguration = {
      program_config_id,
      program_product_id,
      domain_id
    };

    return this.http.post<BaseApiResponse<ICreatedProductFeedUrl>>(environment.apiUrl + `/campaigns/${programID}/products/store`, productConfiguration);
  }

  public getGeneratedProductsConfigurations(campaignId: number): Observable<PageableApiResponse<{ products_data?: IGeneratedProductConfiguration[] }>> {
    return this.http.get<PageableApiResponse<{ products_data?: IGeneratedProductConfiguration[] }>>(
      environment.apiUrl + `/campaigns/${campaignId}/products/list/generated`
    );
  }
}
